export enum NotificationType {
  Success,
  Warning,
  Error,
}
